import { render, staticRenderFns } from "./OTPAuthenticationAndVAToKienLongBankDialog.vue?vue&type=template&id=8bc515f6&scoped=true"
import script from "./OTPAuthenticationAndVAToKienLongBankDialog.vue?vue&type=script&lang=js"
export * from "./OTPAuthenticationAndVAToKienLongBankDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc515f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc515f6')) {
      api.createRecord('8bc515f6', component.options)
    } else {
      api.reload('8bc515f6', component.options)
    }
    module.hot.accept("./OTPAuthenticationAndVAToKienLongBankDialog.vue?vue&type=template&id=8bc515f6&scoped=true", function () {
      api.rerender('8bc515f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/OTPAuthenticationAndVAToKienLongBankDialog.vue"
export default component.exports